import React, { createContext, useMemo, type PropsWithChildren } from 'react';
import { useLoomTouchpointVariantWithAdControls } from '@atlassian/jira-issue-view-common/src/component/loom-videos/use-loom-touchpoint-variant-with-ad-controls/index.tsx';
import { LOOM_QUICK_ADD_AD_CONTROL_DISMISS_KEY } from '@atlassian/jira-issue-view-common/src/component/loom-videos/constants.tsx';
import type { LoomTouchpointVariantType } from '@atlassian/jira-loom-utils/src/controllers/use-loom-touchpoint-variant/types.tsx';
import { useUserHasConfluenceAccess } from '@atlassian/jira-confluence-integration-controls/src/controllers/use-user-has-confluence-access/index.tsx';
import { JIRA_ISSUE_QUICK_ACTIONS } from '@atlassian/jira-issue-create-confluence-content/src/common/constants/embedded-confluence-source.tsx';

type CrossFlowPostOfficeContextType = {
	loomTouchpointVariant: LoomTouchpointVariantType | null;
	hasConfluenceAccess: boolean | null;
};

export const CrossFlowPostOfficeContext = createContext<CrossFlowPostOfficeContextType>({
	loomTouchpointVariant: null,
	hasConfluenceAccess: null,
});

export const CrossFlowPostOfficeProvider = ({ children }: PropsWithChildren<unknown>) => {
	const { loomTouchpointVariant } = useLoomTouchpointVariantWithAdControls(
		LOOM_QUICK_ADD_AD_CONTROL_DISMISS_KEY,
	);
	const hasConfluenceAccess = useUserHasConfluenceAccess(JIRA_ISSUE_QUICK_ACTIONS).hasAccess;

	const context = useMemo(() => {
		return {
			loomTouchpointVariant,
			hasConfluenceAccess,
		};
	}, [loomTouchpointVariant, hasConfluenceAccess]);

	return (
		<CrossFlowPostOfficeContext.Provider value={context}>
			{children}
		</CrossFlowPostOfficeContext.Provider>
	);
};
